export default "__VITE_ASSET__Po3nx_pd__"